// Inverse of ruby's to_camelback_keys method.
// Recursively converts camelBack JSON-style hash keys to Rubyish snake_case hash keys.
const strToSnakecase = (str: string): string =>
  str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
const toSnakecaseKeys = (camelProps: any): any => {
  if (camelProps?.constructor !== Object) return camelProps;
  return Object.fromEntries(
    Object.entries(camelProps).map(([key, value]) => [
      strToSnakecase(key),
      toSnakecaseKeys(value),
    ]),
  );
};
export default toSnakecaseKeys;
